import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { PureComponent, createRef } from 'react';
import { createInspectorSelectors, computeSelectorSource, } from '../selectors.js';
import { changeQueryFormValues, selectedPreviewTab, selectQueryKey, } from '../reducers.js';
import { QueryList } from '../components/QueryList.js';
import { QueryForm } from '../components/QueryForm.js';
import { QueryPreview } from './QueryPreview.js';
class RtkQueryInspector extends PureComponent {
    constructor(props) {
        super(props);
        this.inspectorRef = createRef();
        this.isWideIntervalRef = null;
        this.selectors = createInspectorSelectors();
        this.updateSizeMode = () => {
            if (this.inspectorRef.current) {
                const isWideLayout = this.inspectorRef.current.offsetWidth >= RtkQueryInspector.wideLayout;
                if (isWideLayout !== this.state.isWideLayout) {
                    this.setState({ isWideLayout });
                }
            }
        };
        this.handleQueryFormValuesChange = (values) => {
            this.props.dispatch(changeQueryFormValues(values));
        };
        this.handleSelectQuery = (queryInfo) => {
            this.props.dispatch(selectQueryKey(queryInfo));
        };
        this.handleTabChange = (tab) => {
            this.props.dispatch(selectedPreviewTab(tab));
        };
        this.state = {
            isWideLayout: true,
            selectorsSource: computeSelectorSource(props, null),
        };
    }
    static getDerivedStateFromProps(props, state) {
        const selectorsSource = computeSelectorSource(props, state.selectorsSource);
        if (selectorsSource !== state.selectorsSource) {
            return {
                selectorsSource,
            };
        }
        return null;
    }
    componentDidMount() {
        this.updateSizeMode();
        this.isWideIntervalRef = setInterval(this.updateSizeMode, 300);
    }
    componentWillUnmount() {
        if (this.isWideIntervalRef) {
            clearTimeout(this.isWideIntervalRef);
        }
    }
    render() {
        const { selectorsSource, isWideLayout } = this.state;
        const allVisibleRtkResourceInfos = this.selectors.selectAllVisbileQueries(selectorsSource);
        const currentResInfo = this.selectors.selectCurrentQueryInfo(selectorsSource);
        const apiStates = this.selectors.selectApiStates(selectorsSource);
        const hasNoApi = apiStates == null;
        const searchQueryRegex = this.selectors.selectSearchQueryRegex(selectorsSource);
        return (_jsxs("div", { ref: this.inspectorRef, "data-wide-layout": +this.state.isWideLayout, css: (theme) => ({
                display: 'flex',
                flexFlow: 'column nowrap',
                overflow: 'hidden',
                width: '100%',
                height: '100%',
                fontFamily: 'monaco, Consolas, "Lucida Console", monospace',
                fontSize: '12px',
                WebkitFontSmoothing: 'antialiased',
                lineHeight: '1.5em',
                backgroundColor: theme.BACKGROUND_COLOR,
                color: theme.TEXT_COLOR,
                '&[data-wide-layout="1"]': {
                    flexFlow: 'row nowrap',
                },
            }), children: [_jsxs("div", { css: (theme) => ({
                        display: 'flex',
                        flex: '0 0 auto',
                        height: '50%',
                        width: '100%',
                        borderColor: theme.TAB_BORDER_COLOR,
                        '&[data-wide-layout="0"]': {
                            borderBottomWidth: 1,
                            borderStyle: 'solid',
                        },
                        '&[data-wide-layout="1"]': {
                            height: '100%',
                            width: '44%',
                            borderRightWidth: 1,
                            borderStyle: 'solid',
                        },
                        flexFlow: 'column nowrap',
                        '& > form': {
                            flex: '0 0 auto',
                            borderBottomWidth: '1px',
                            borderBottomStyle: 'solid',
                            borderColor: theme.LIST_BORDER_COLOR,
                        },
                        '& > ul': {
                            flex: '1 1 auto',
                            overflowX: 'hidden',
                            overflowY: 'auto',
                            maxHeight: 'calc(100% - 70px)',
                        },
                    }), "data-wide-layout": +this.state.isWideLayout, children: [_jsx(QueryForm, { searchQueryRegex: searchQueryRegex, values: selectorsSource.monitorState.queryForm.values, onFormValuesChange: this.handleQueryFormValuesChange }), _jsx(QueryList, { onSelectQuery: this.handleSelectQuery, resInfos: allVisibleRtkResourceInfos, selectedQueryKey: selectorsSource.monitorState.selectedQueryKey })] }), _jsx(QueryPreview, { selectorsSource: this.state.selectorsSource, selectors: this.selectors, resInfo: currentResInfo, selectedTab: selectorsSource.monitorState.selectedPreviewTab, onTabChange: this.handleTabChange, isWideLayout: isWideLayout, hasNoApis: hasNoApi })] }));
    }
}
RtkQueryInspector.wideLayout = 600;
export default RtkQueryInspector;
